export const SELECT_ALL_OPTION = {
  label: 'Select All',
  value: '_selectAll_',
};

export const SELECT_SELECTION = {
  label: 'Selection',
  value: '_selection_',
};
